module.exports = __webpack_public_path__ + "img/intro14.ddaaab11.jpg";